<template>
  <div class="loader-back" unselectable="on">
    <table class="main-table">
      <tr height="100%">
        <td width="30%"></td>
        <td width="30%" align="center">Ошибка авторизации</td>
        <td width="30%"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "ErrorPage"
}
</script>

<style scoped>

</style>
